import { useEffect, useState } from "react";
import EformMultiSelectCheckbox from "@/components/EformMultiSelectCheckbox/index"
import PropTypes from 'prop-types';
import { useFeature } from "@/hooks/use-feature/index";
import { featureConstant } from "@/constants/configuration/feature";

const CellDropdownComponent = ({
    isReadOnly,
    schema,
    payload,
    parentProps,
    inputProps,
    setInputProps,
    updatePayload,
    validateSchema,
    getFieldValue,
}) => {
    const [multiSelectLists, setMultiSelectLists] = useState([]);
    const isSubmittalsEnabled = useFeature(featureConstant.SUBMITTALS);

    useEffect(() => {
        const filledValue = getFieldValue(payload, parentProps);
        if (schema["x-uioptions"]) {
            const uiOptions = isSubmittalsEnabled && !Array.isArray(schema["x-uioptions"])
                ? schema["x-uioptions"]?.options
                : schema["x-uioptions"];
            const formatedList = uiOptions?.map((list) => ({...list, $selected: filledValue?.includes(list.value)}));
            setMultiSelectLists(formatedList);
        }
    }, [payload])

	function updateMultiSelectLists(multiSelectLists){
		const updatedItem = multiSelectLists.filter(field => field.$selected === true).map(filter => filter.value);
		setInputProps({ ...inputProps, updatedItem});
		updatePayload(updatedItem);
		validateSchema(updatedItem);
	}

    useEffect(() => {
        setInputProps({
            ...inputProps,
            disabled: isReadOnly,
            value: getFieldValue(payload, parentProps),
        });
    }, [payload]);

    return (
        <EformMultiSelectCheckbox items={multiSelectLists} onChangeFunc={updateMultiSelectLists} placeholder={isReadOnly ? null : "Select Option"} disable={isReadOnly} />
    );
};

CellDropdownComponent.propTypes = {
    isReadOnly: PropTypes.any,
    schema: PropTypes.any,
    payload: PropTypes.any,
    parentProps: PropTypes.any,
    inputProps: PropTypes.any,
    setInputProps: PropTypes.any,
    updatePayload: PropTypes.any,
    validateSchema: PropTypes.any,
    getFieldValue: PropTypes.any,
};

export default CellDropdownComponent;
